import React, { useState, useRef, useEffect, useContext } from 'react';
import Logo from '../images/logo.png';
import Menu from '../images/menu.png';
import Close from '../images/close.png';
import { Link, useLocation } from "react-router-dom";
import LocaleContext from '../Contexts/LocaleContext';
import { translate } from 'react-polyglot';

function Header({ t }) {
  const { setLocale } = useContext(LocaleContext);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const menuItems = [
    { label: t('games'), href: '/#game' },
    { label: t('tools'), href: '/#tools' },
    { label: t('bridge'), href: 'https://bridge.zkcandy.io' },
  ];

  return (
    <nav className="header flex justify-center">
      <div className="container items-center justify-between lg:flex hidden">
        <div className="flex items-center gap-6 text-[1.8rem]">
          <Link to="/" className="logo me-5">
            <img src={Logo} alt="logo" />
          </Link>
          {location.pathname !== '/login' && (
            <Link to="https://app.layer3.xyz/campaigns/zkcandy" target="_blank" rel="noopener noreferrer">
              <div className="page-title">{t('layer3_quests')}</div>
            </Link>
          )}
        </div>

        {location.pathname !== '/login' && (
          <div className="flex items-center menus gap-10">
            {menuItems.map((item, index) => (
              <div key={index}>
                {item.href.includes('http') ? (
                  <a href={item.href} className="menu" target="_blank" rel="noopener noreferrer">{item.label}</a>
                ) : (
                  <a href={item.href} className="menu">{item.label}</a>
                )}
              </div>
            ))}
            <a href="https://passport.zkcandy.io" className="btn-connect tooltip-container" target="_blank" rel="noopener noreferrer">
              {t('candy_passport')}
              <div className="tooltip">{t('login_create')}</div>
            </a>
          </div>
        )}
      </div>

      <div className="relative inline-block text-left lg:hidden flex justify-between w-full">
        <Link to="/" className="logo ms-5">
          <img src={Logo} alt="logo" />
        </Link>
        <button onClick={toggleDropdown} className="px-4 py-2">
          <div className="btn-menu">
            <img src={Menu} alt="menu" />
          </div>
        </button>

        {isOpen && (
          <div
            ref={dropdownRef}
            className="dropdown fixed top-0 rounded-md shadow-lg bg-[#00000acc] w-full h-[100svh] z-10 flex justify-center transition-all"
          >
            <div className="p-1 flex justify-center flex-col items-center gap-8 text-[2.5rem]">
              {location.pathname !== '/login' && (
                <Link to="https://app.layer3.xyz/campaigns/zkcandy" target="_blank" rel="noopener noreferrer" onClick={toggleDropdown}>
                  <div className="page-title">{t('layer3_quests')}</div>
                </Link>
              )}
              {menuItems.map((item, index) => (
                <div key={index}>
                  {item.href.includes('http') ? (
                    <a href={item.href} className="menu" target="_blank" rel="noopener noreferrer">{item.label}</a>
                  ) : (
                    <a href={item.href} className="menu" onClick={toggleDropdown}>{item.label}</a>
                  )}
                </div>
              ))}
              <a href="https://passport.zkcandy.io" className="btn-connect" target="_blank" rel="noopener noreferrer">{t('passport')}</a>

              <div className="w-[30px] mt-10" onClick={toggleDropdown}>
                <img src={Close} alt="close menu" className="w-full" />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="flex items-center mr-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
        </svg>
        <select className="bg-transparent font-montserrat" onChange={e => setLocale(e.target.value)}>
          <option value="en">EN</option>
          <option value="kr">KR</option>
        </select>
      </div>

    </nav>
  );
}

export default translate()(Header);